export default __webpack_public_path__ + "static/087-178c86cb6fe45ca306ba398e27cdcf5a.jpg";